import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { sendDeal } from 'actions/bookActions';
import { toggleModal } from 'redux/actions/modalActions';
import LoadingOverlayLayout from 'layouts/LoadingOverlayLayout/LoadingOverlayLayout';

import EmailDealForm from 'components/EmailDeal/EmailDeal';
import EmailDealResult from 'components/EmailDeal/EmailDealResult';

/* istanbul ignore next */
const mapStateToProps = state => ({
  initialValues: {
    emailAddress: state.bookState.getIn(['entities', 'passengers', '0', 'email']),
    name: state.bookState.getIn(['entities', 'passengers', '0', 'firstName']),
  },
  emailDealResult: state.bookState.get('emailDealResult'),
  isMobileBreakpoint: state.appState.get('isMobileBreakpoint'),
  appState: state.appState,
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  onSubmit: bindActionCreators(sendDeal, dispatch),
  closeModal: bindActionCreators(toggleModal, dispatch),
});

export class EmailDealLayout extends Component {
  static propTypes = {
    appState: ImmutablePropTypes.map,
    closeModal: PropTypes.func.isRequired,
    emailDealResult: PropTypes.bool,
    initialValues: PropTypes.shape({
      emailAddress: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
    onSubmit: PropTypes.func.isRequired,
    isMobileBreakpoint: PropTypes.bool,
  };

  componentWillMount() {
    this.setState({
      isMobileBreakpoint: this.props.isMobileBreakpoint,
    });
  }

  render() {
    const { isMobileBreakpoint } = this.state;
    const { emailDealResult, closeModal, initialValues, onSubmit, appState } = this.props;

    return emailDealResult === undefined ? (
      <LoadingOverlayLayout isLoading={appState.get('savingEmailDeal', false)}>
        <EmailDealForm initialValues={initialValues} onSubmit={onSubmit} isMobileBreakpoint={isMobileBreakpoint} />
      </LoadingOverlayLayout>
    ) : (
      <EmailDealResult emailDealResult={emailDealResult} close={closeModal} />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailDealLayout);



/** WEBPACK FOOTER **
 ** ./src/layouts/EmailDealLayout/EmailDealLayout.jsx
 **/